
/**
 * Basic URL param available for every pages.
 */
export interface PageBasicParams {
	/**
	 * Returns current selected language (from Express).
	 */
	readonly language: 'en' | 'es' | 'fr';
	/**
	 * The requested page path, using to query data of the corresponding page.
	 */
	readonly pagePath?: string;
	/**
	 * The entire path / URL of the requested page.
	 */
	readonly requestedURL?: string;
}

/**
 * URL Query params used for previewing generic pages.
 */
export interface PageUrlQuery {
	/**
	 * The preview key used to preview pages from Strapi CMS.
	 */
	readonly previewKey?: string
}

/**
 * Basic props available for every pages.
 */
export interface PageBasicProps {
	/**
	 * Returned data from Strapi's DB using Apollo GraphQL API.
	 */
	readonly content?: any,
	/**
	 * Returns the current path of the page.
	 */
	readonly currentPath: string,
	/**
	 * Returns the current language of the user.
	 */
	readonly currentLang: string,
}

/**
 * Defines the target of the page. Used for pages and components customizations.
 */
export enum PAGE_TYPE {
	b2c = 'B2C',
	b2b = 'B2B',
}

/**
 * Defines the possible values for sections backgroundColors
 */
export enum BACKGROUND_COLOR {
	beige = 'beige',
	beigeLight = 'beigeLight',
	blue = 'blue',
	prune = 'prune',
	red = 'red',
	transparent = 'transparent',
	white = 'white',
}
